// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const MAKE_TODO_DESCRIPTOR = msg({
	message: 'Make to-do',
	comment: 'Message menu action that turns a chat message into a to-do. Keep it short.',
});
export const TODO_ADDED_DESCRIPTOR = msg({
	message: 'To-do added',
	comment: 'Toast shown after a message was turned into a to-do.',
});
export const TODO_FAILED_DESCRIPTOR = msg({
	message: 'Could not add the to-do. Try again.',
	comment: 'Toast shown when creating a to-do failed.',
});
export const TODOS_DESCRIPTOR = msg({
	message: 'To-dos',
	comment: 'Name of the to-dos page in the sidebar and its header.',
});
export const MY_TODOS_DESCRIPTOR = msg({
	message: 'My to-dos',
	comment: 'Tab showing to-dos assigned to the current user.',
});
export const TEAM_BOARD_DESCRIPTOR = msg({
	message: 'Team board',
	comment: 'Tab showing every to-do as a board with To do, Doing and Done columns.',
});
export const SEARCH_OR_ADD_TODO_DESCRIPTOR = msg({
	message: 'Search or add a to-do',
	comment: 'Placeholder in the field that filters to-dos and adds a new one on Enter.',
});
export const ADD_TODO_NAMED_DESCRIPTOR = msg({
	message: 'Add “{title}”',
	comment: 'Button that adds the typed text as a new to-do. {title} is what the person typed.',
});
export const NO_TODOS_MATCH_DESCRIPTOR = msg({
	message: 'No to-dos match “{query}”.',
	comment: 'Shown when the search finds nothing.',
});
export const NO_TODOS_DESCRIPTOR = msg({
	message: 'Nothing to do. Type above to add a to-do, or use Make to-do on any message.',
	comment: 'Empty state of My to-dos.',
});
export const OVERDUE_DESCRIPTOR = msg({message: 'Overdue', comment: 'Group of to-dos past their due date.'});
export const TODAY_DESCRIPTOR = msg({message: 'Today', comment: 'Group of to-dos due today.'});
export const UPCOMING_DESCRIPTOR = msg({message: 'Upcoming', comment: 'Group of to-dos due later.'});
export const NO_DATE_DESCRIPTOR = msg({message: 'No date', comment: 'Group of to-dos with no due date.'});
export const DONE_DESCRIPTOR = msg({message: 'Done', comment: 'Board column and group for finished to-dos.'});
export const TODO_COLUMN_DESCRIPTOR = msg({message: 'Backlog', comment: 'Board column for to-dos not started.'});
export const INPUT_COLUMN_DESCRIPTOR = msg({
	message: 'Input needed',
	comment: 'Board column for to-dos waiting on someone to answer or decide.',
});
export const DOING_COLUMN_DESCRIPTOR = msg({
	message: 'In progress',
	comment: 'Board column for to-dos being worked on.',
});
export const QA_COLUMN_DESCRIPTOR = msg({
	message: 'QA',
	comment: 'Board column for to-dos being checked before they are done.',
});
export const ARCHIVE_DESCRIPTOR = msg({message: 'Archive', comment: 'Button that archives one to-do.'});
export const ARCHIVE_COLUMN_DESCRIPTOR = msg({
	message: 'Archive all',
	comment: 'Board column button that archives every to-do in that column.',
});
export const ARCHIVE_COLUMN_CONFIRM_DESCRIPTOR = msg({
	message: 'Archive all {count} to-dos in {column}?',
	comment: 'Confirmation before archiving a whole board column. Preserve {count} and {column}.',
});
export const ARCHIVED_DESCRIPTOR = msg({message: 'Archived', comment: 'Board filter that shows archived to-dos.'});
export const RESTORE_DESCRIPTOR = msg({
	message: 'Restore',
	comment: 'Button that brings an archived to-do back to the board.',
});
export const NO_ARCHIVED_DESCRIPTOR = msg({message: 'Nothing archived yet.', comment: 'Empty archive view.'});
export const ARCHIVED_COUNT_DESCRIPTOR = msg({
	message: 'Archived {count} to-dos',
	comment: 'Toast after archiving a column. Preserve {count}.',
});
export const EVERYONE_DESCRIPTOR = msg({message: 'Everyone', comment: 'Board filter showing everyone’s to-dos.'});
export const MINE_DESCRIPTOR = msg({message: 'Mine', comment: 'Board filter showing only my to-dos.'});
export const PERSONAL_DESCRIPTOR = msg({
	message: 'Personal',
	comment: 'A personal to-do, seen only by the person who made it; also its heading in My to-dos.',
});
export const TEAM_DESCRIPTOR = msg({
	message: 'Team',
	comment: 'A team to-do on the team board; also its heading in My to-dos and shown for team to-dos not linked to a chat.',
});
export const DELETE_TODO_DESCRIPTOR = msg({message: 'Delete to-do', comment: 'Button that deletes a to-do.'});
export const MARK_DONE_DESCRIPTOR = msg({
	message: 'Mark done: {title}',
	comment: 'Screen-reader label of the checkbox that finishes a to-do.',
});
export const MARK_NOT_DONE_DESCRIPTOR = msg({
	message: 'Mark not done: {title}',
	comment: 'Screen-reader label of the checkbox that reopens a finished to-do.',
});
export const CHAT_DETAILS_DESCRIPTOR = msg({
	message: 'To-dos and files',
	comment: 'Channel header button that opens the panel with this chat’s to-dos and shared files.',
});
export const FILES_DESCRIPTOR = msg({message: 'Files', comment: 'Tab listing files shared in this chat.'});
export const ADD_TODO_HERE_DESCRIPTOR = msg({
	message: 'Add a to-do to this chat',
	comment: 'Placeholder of the field in the chat panel that adds a to-do linked to the chat.',
});
export const NO_CHAT_TODOS_DESCRIPTOR = msg({
	message: 'No to-dos in this chat yet. Use Make to-do on a message, or type above.',
	comment: 'Empty state of the to-dos tab in the chat panel.',
});
export const NO_CHAT_FILES_DESCRIPTOR = msg({
	message: 'Files shared in this chat will be listed here.',
	comment: 'Empty state of the files tab in the chat panel.',
});
export const FILES_INDEXING_DESCRIPTOR = msg({
	message: 'Still indexing this chat. Files will appear shortly.',
	comment: 'Shown while search is building its index for the chat.',
});
export const SHOW_DONE_DESCRIPTOR = msg({
	message: 'Show {count} done',
	comment: 'Button that reveals finished to-dos. {count} is how many.',
});
export const HIDE_DONE_DESCRIPTOR = msg({message: 'Hide done', comment: 'Button that hides finished to-dos.'});
export const DESKTOP_APP_DESCRIPTOR = msg({
	message: 'Desktop app',
	comment: 'Sidebar button that opens the desktop app downloads.',
});
export const DOWNLOAD_FOR_MAC_DESCRIPTOR = msg({
	message: 'Download for Mac',
	comment: 'Link that downloads the Pioneerchat desktop app for macOS.',
});
export const DOWNLOAD_FOR_WINDOWS_DESCRIPTOR = msg({
	message: 'Download for Windows',
	comment: 'Link that downloads the Pioneerchat desktop app for Windows.',
});
export const DOWNLOAD_NOT_READY_DESCRIPTOR = msg({
	message: 'Not uploaded yet',
	comment: 'Shown next to a desktop app download that is not on the server yet.',
});
export const ACTIVITY_DESCRIPTOR = msg({
	message: 'Activity',
	comment: 'Sidebar link to messages that mention you.',
});
export const SEARCH_DESCRIPTOR = msg({
	message: 'Search',
	comment: 'Sidebar button that opens search for chats and people.',
});
export const NEW_MESSAGE_DESCRIPTOR = msg({
	message: 'New message',
	comment: 'Button next to the Direct messages heading that starts a new conversation.',
});
export const HIDE_DETAILS_DESCRIPTOR = msg({
	message: 'Hide tasks',
	comment: "Chat header button that hides the pane with this chat's to-dos and files.",
});
export const SHOW_DETAILS_DESCRIPTOR = msg({
	message: 'Show tasks',
	comment: "Chat header button that shows the pane with this chat's to-dos and files.",
});
export const CHATS_LABEL_DESCRIPTOR = msg({
	message: 'Chats',
	comment: 'Sidebar heading above the list of team chats and direct messages.',
});
export const NEW_CHAT_DESCRIPTOR = msg({
	message: 'New chat',
	comment: 'Button next to the Chats heading. Opens choices to create a channel or message someone.',
});
export const NEW_CHANNEL_DESCRIPTOR = msg({
	message: 'New channel',
	comment: 'Menu item that creates a team channel. The form lets you pick text or voice.',
});
export const IMPORT_TRELLO_DESCRIPTOR = msg({
	message: 'Import from Trello',
	comment: 'Team board button that adds the cards from a Trello board export file.',
});
export const IMPORTING_TRELLO_DESCRIPTOR = msg({
	message: 'Importing {done} of {total}…',
	comment: 'Shown while Trello cards are being added. Preserve {done} and {total}.',
});
export const TRELLO_IMPORTED_DESCRIPTOR = msg({
	message: 'Added {added} to-dos from Trello. {skipped} were already here.',
	comment: 'Toast after a Trello import. Preserve {added} and {skipped}.',
});
export const TRELLO_IMPORT_FAILED_DESCRIPTOR = msg({
	message:
		"That file isn't a Trello board export. In Trello open the board menu, then Print, export and share, then Export as JSON.",
	comment: 'Toast when the chosen file cannot be read as a Trello export.',
});
export const DETAILS_DESCRIPTOR = msg({
	message: 'Details',
	comment: "Phone chat header button that opens this chat's to-dos and files.",
});
export const TAB_CHATS_DESCRIPTOR = msg({message: 'Chats', comment: 'Phone bottom tab: list of chats.'});
export const TAB_TODOS_DESCRIPTOR = msg({message: 'To-dos', comment: 'Phone bottom tab: to-dos and team board.'});
export const TAB_ACTIVITY_DESCRIPTOR = msg({
	message: 'Activity',
	comment: 'Phone bottom tab: mentions and replies.',
});
export const TAB_SEARCH_DESCRIPTOR = msg({message: 'Search', comment: 'Phone bottom tab: search chats and people.'});
export const YOUR_PROFILE_DESCRIPTOR = msg({
	message: 'You and settings',
	comment: 'Phone button with your picture that opens your profile and settings.',
});
